module.exports = __webpack_public_path__ + "img/theme-one.81220d56.png";